<div class="auth-layout">
  <aside class="auth-image-side d-none d-lg-block">
    @for (slide of slides; track slide.src; let i = $index) {
      <img
        [src]="slide.src"
        [alt]="slide.alt"
        class="auth-image"
        [class.auth-image--active]="i === activeIndex()"
        aria-hidden="true"
      />
    }
    <div class="auth-image-overlay"></div>
    <footer class="auth-image-footer">
      <img src="/img/common/logo.png" alt="Sourcing Souk" class="auth-image-logo" />
      <div class="auth-image-progress" role="tablist" aria-label="Slide progress">
        @for (slide of slides; track slide.src; let i = $index) {
          <button
            type="button"
            class="auth-image-progress__seg"
            role="tab"
            [attr.aria-selected]="i === activeIndex()"
            (click)="selectSlide(i)"
            [attr.aria-label]="'Show slide ' + (i + 1) + ' of ' + slides.length"
          >
            @if (i < activeIndex()) {
              <span class="auth-image-progress__fill auth-image-progress__fill--done"></span>
            } @else if (i === activeIndex()) {
              <span
                class="auth-image-progress__fill auth-image-progress__fill--active"
                [style.animation-duration.ms]="slideIntervalMs"
              ></span>
            }
          </button>
        }
      </div>
    </footer>
  </aside>

  <main class="auth-form-side">
    <router-outlet />
  </main>
</div>
